<template>
  <div class="canvas-container">
    <div>
      <div class="text-brand-5 text-weight-bold assinatura-texto">
        {{ tipoTitulo[tipoAssinatura] }}
      </div>
    </div>

    <div class="row q-gutter-y-md">
      <Canvas
        class="col-12"
        v-if="tipoAssinatura == 'manual'"
        @update="atualizarImagem"
        :restart="restartSignature"
        :go="saveSignature"
        @assinar="salvarSignature()"
        :tipoAssinatura="tipoAssinatura"
        @remover="removerAssinatura"
      />
      <div
        class="row col-12 q-mt-lg items-center container-autenticacao-pin"
        v-if="tipoAssinatura === 'pin'"
      >
        <q-icon class="q-mr-xs" name="lock" size="28px" />
        <div class="col-md-2 col-xs-6">
          <q-input v-model="pin" type="password" dense outlined />
        </div>
      </div>

      <div
        class="row col-12 q-mt-lg q-ml-md items-center"
        v-if="tipoAssinatura === 'biometria'"
      >
        <div>
          <q-img
            v-if="biometriaVerificacaoConst"
            class="imagem-biometria"
            src="../../../../assets/bioOK.png"
            @click="biometriaModal = true"
          />
          <q-img
            v-else
            class="imagem-biometria"
            src="../../../../assets/bioRequest.png"
            @click="biometriaModal = true"
          />
          <span class="q-ml-sm text-bold text-brand-5" style="font-size: 16px"
            >Clique no icone da digital para reconhecimento da biometria.</span
          >
          <BiometriaPT
            :modal="biometriaModal"
            :matricula="assinante?.matricula"
            :unidadeId="pt?.unidadeId"
            :titulo="'Verificação de Biometria'"
            :tipoBiometria="'verificacao'"
            @negativePrint="atualizarBiometria"
            @resultadoVerificacao="biometriaVerificacao"
          />
        </div>
      </div>

      <div
        @click="facial = true"
        style="cursor: pointer"
        class="row col-12 q-mt-lg q-ml-md items-center container-autenticacao-assinatura no-wrap"
        v-if="tipoAssinatura === 'facial'"
      >
        <div class="relative-position" style="display: inline-block">
          <q-icon
            size="60px"
            class="q-mr-xs"
            name="face"
            :color="imagemBase64 == null ? 'negative' : 'positive'"
          />

          <q-icon
            :name="imagemBase64 == null ? 'cancel' : 'check_circle'"
            :style="{
              color: imagemBase64 == null ? '#C62828' : '#2E7D32',
            }"
            size="22px"
            class="absolute-bottom-right"
            style="bottom: 2px; right: -2px; z-index: 0"
          >
            <q-tooltip
              anchor="top middle"
              self="bottom middle"
              :class="
                imagemBase64 == null
                  ? 'bg-gray text-white'
                  : 'bg-gray text-white'
              "
            >
              {{
                imagemBase64 == null
                  ? "Face não capturada"
                  : "Face capturada com sucesso"
              }}
            </q-tooltip>
          </q-icon>
        </div>
        <span class="q-ml-sm text-bold text-brand-5" style="font-size: 16px"
          >Clique aqui para reconhecimento da face, após leitura, clique em
          CONFIRMAR FACE</span
        >
        <VerificacaoFacial
          :userId="assinante?.responsavelId"
          v-model="facial"
          @close="fecharFacial"
          @sendFace="receberFace"
        />
      </div>

      <div
        class="row col-12 q-mt-lg items-center container-autenticacao-cracha"
        v-if="tipoAssinatura === 'cracha'"
      >
        <div class="relative-position" style="display: inline-block">
          <q-icon
            size="60px"
            class="q-mr-xs"
            name="badge"
            :color="
              codigoCracha == null || codigoCracha == ''
                ? 'negative'
                : 'positive'
            "
          />

          <q-icon
            :name="
              codigoCracha == null || codigoCracha == ''
                ? 'cancel'
                : 'check_circle'
            "
            :style="{
              color:
                codigoCracha == null || codigoCracha == ''
                  ? '#C62828'
                  : '#2E7D32',
            }"
            size="22px"
            class="absolute-bottom-right"
            style="bottom: 2px; right: -2px; z-index: 0"
          >
            <q-tooltip
              anchor="top middle"
              self="bottom middle"
              :class="
                codigoCracha == null || codigoCracha == ''
                  ? 'bg-gray text-white'
                  : 'bg-gray text-white'
              "
            >
              {{
                codigoCracha == null || codigoCracha == ""
                  ? "Código do crachá não inserido"
                  : "Código do crachá inserido"
              }}
            </q-tooltip>
          </q-icon>
        </div>
        <div class="col-md-3 col-xs-6 q-ml-md">
          <div class="text-brand-5 text-weight-bold q-mb-sm">
            Código do Crachá
          </div>
          <q-input
            v-model="codigoCracha"
            dense
            outlined
            placeholder="Digite o código do crachá"
            @input="validarCracha"
          />
        </div>
      </div>
    </div>
    <div
      v-if="
        tipoAssinatura == 'eletronica' ||
        tipoAssinatura == 'pin' ||
        tipoAssinatura == 'token' ||
        tipoAssinatura == 'facial' ||
        tipoAssinatura == 'cracha' ||
        tipoAssinatura == 'biometria'
      "
      class="q-mt-lg"
    >
      <div>
        <q-btn
          label="Confirmar Assinatura"
          color="positive"
          icon="check_circle_outline"
          no-caps
          :disable="
            (tipoAssinatura == 'facial' && imagemBase64 == null) ||
            (tipoAssinatura == 'cracha' &&
              (codigoCracha == null || codigoCracha == '')) ||
            (tipoAssinatura == 'biometria' && !biometriaVerificacaoConst)
          "
          @click="
            tipoAssinatura == 'facial'
              ? coletarImagem()
              : tipoAssinatura == 'cracha'
              ? coletarCracha()
              : tipoAssinatura == 'biometria'
              ? coletarBiometriaDigital()
              : coletarAssinatura()
          "
        />
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import { useStore } from "vuex";
import Canvas from "./Canvas.vue";
import { useQuasar } from "quasar";
import BiometriaPT from "./BiometriaPT.vue";
import VerificacaoFacial from "../../../requisicao/components/VerificacaoFacial.vue";

export default {
  components: { Canvas, BiometriaPT, VerificacaoFacial },
  props: ["usuarioPodeEditar", "assinante", "tipoAssinatura"],
  emits: ["closeDialog"],
  setup(props, { emit }) {
    const columns = [
      {
        name: "atividade",
        align: "left",
        label: "Atividade",
        field: "atividadeNome",
        sortable: false,
      },
      {
        name: "participaAtividade",
        align: "left",
        label: "Participa",
        field: "participaAtividade",
        format: (val) => {
          return val ? "sim" : "nao";
        },
        sortable: false,
      },
      {
        name: "url",
        align: "left",
        label: "Url",
        field: "url",
        sortable: false,
      },
    ];
    let imagemBase64 = ref(null);
    const store = useStore();
    const quasar = useQuasar();
    let restartSignature = ref(0);
    let saveSignature = ref(0);
    let biometriaModal = ref(false);
    const pt = ref(null);
    const tipoTitulo = ref({
      manual: "Assinatura:",
      biometria: "Biometria:",
      pin: "Pin:",
      token: "Token:",
      facial: "Facial:",
      cracha: "Crachá:",
    });
    const pin = ref("");
    const facial = ref(false);
    const biometriaVerificacaoConst = ref(false);
    const codigoCracha = ref("");

    const buscarDadosPt = async () => {
      try {
        const ptId = props.assinante?.ptId;

        if (!ptId) {
          console.error(
            "ptId não encontrado nas props do assinante (encerramento)"
          );
          return;
        }

        const response = await store.dispatch("pdt/buscarDetalhePt", {
          ptId: ptId,
        });
        pt.value = response.data.resultado.dados;
      } catch (error) {
        console.warn("Erro ao buscar dados da PT:", error);
      }
    };

    buscarDadosPt();

    const atualizarImagem = async (value) => {
      imagemBase64.value = value;
      await coletarAssinatura();
    };

    const salvarSignature = async () => {
      saveSignature.value++;
    };

    const atualizarBiometria = async (value) => {
      imagemBase64.value = value;
    };

    const coletarBiometriaDigital = async () => {
      try {
        if (!imagemBase64.value && props.tipoAssinatura == "biometria") {
          quasar.notify({
            message: "A Biometria precisa ser coletada",
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {},
              },
            ],
          });
          return;
        }

        if (!biometriaVerificacaoConst.value && imagemBase64.value != null) {
          quasar.notify({
            message:
              "A biometria não coincide com a digital verificada, faça o procedimento novamente ou escolha outro método de autenticação.",
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {},
              },
            ],
          });
          imagemBase64.value = null;
          return;
        }

        // buscarUrl para upload
        const resposta = await store.dispatch("pdt/getUpload", {
          ptId: props.assinante.ptId,
        });

        // inicio upload imagem
        let formAttributes = resposta.data.resultado.dados.formAttributes;
        let formInputs = resposta.data.resultado.dados.formInputs;

        const formData = new FormData();

        for (let input in formInputs) {
          formData.append(input, formInputs[input]);
        }

        let imageDataUrl = imagemBase64.value;
        if (!imageDataUrl.startsWith("data:image")) {
          imageDataUrl = `data:image/png;base64,${imagemBase64.value}`;
        }

        let file;
        try {
          file = await fetch(imageDataUrl).then((res) => {
            if (!res.ok) {
              throw new Error(`Erro no fetch: ${res.status} ${res.statusText}`);
            }
            return res.blob();
          });
        } catch (fetchError) {
          console.error("Erro no fetch da imagem:", fetchError);
          throw new Error(`Falha ao converter imagem: ${fetchError.message}`);
        }

        formData.append("file", file);

        // Upload com Promise para aguardar completar
        await new Promise((resolve, reject) => {
          var request = new XMLHttpRequest();
          request.onload = function () {
            if (request.status >= 200 && request.status < 300) {
              resolve(request.response);
            } else {
              reject(new Error(`Erro no upload: ${request.status}`));
            }
          };
          request.onerror = () => reject(new Error("Erro de rede no upload"));
          request.open(formAttributes.method, formAttributes.action);
          request.send(formData);
        });
        // fim upload imagem

        // Construir URL da assinatura
        const urlAssinatura = `${formAttributes.action}/${formInputs.key}`;

        // Validar se a URL não está muito longa (evitar erro 431)
        if (urlAssinatura.length > 2000) {
          throw new Error("URL da assinatura muito longa");
        }

        // envio da assinatura para encerramento
        await store.dispatch("pdt/enviarAssinaturaEncerramento", {
          ptId: props.assinante.ptId,
          responsavelId: props.assinante.responsavelId,
          assinaturaTipo: "biometrica",
          assinatura: urlAssinatura,
        });

        quasar.notify({
          message: "Biometria Digital enviada com sucesso",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {},
            },
          ],
        });

        restartSignature.value += 1;
        imagemBase64.value = null;
        emit("closeDialog");
      } catch (error) {
        console.error("Erro no fluxo de biometria digital:", error);
        const mensagemErro =
          error?.response?.data?.erro?.mensagem ||
          error.message ||
          "Erro ao processar biometria digital";

        quasar.notify({
          message: mensagemErro,
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {},
            },
          ],
        });
      }
    };

    const coletarAssinatura = async () => {
      if (!imagemBase64.value && props.tipoAssinatura == "manual") {
        quasar.notify({
          message: "Por Favor, Salve antes de Assinar",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        return;
      }

      if (props.tipoAssinatura == "pin" && !(await verificarPin())) {
        return;
      }

      try {
        if (props.tipoAssinatura == "token") {
          await store.dispatch("pdt/enviarAssinaturaEncerramento", {
            ptId: props.assinante.ptId,
            responsavelId: props.assinante.responsavelId,
            assinaturaTipo: "eletronica",
            assinatura: store.state.autenticacao.token,
          });

          quasar.notify({
            message: "Token enviado com sucesso",
            color: "positive",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          restartSignature.value += 1;
          imagemBase64.value = null;
          emit("closeDialog");
          return;
        }

        if (props.tipoAssinatura == "pin") {
          await store.dispatch("pdt/enviarAssinaturaEncerramento", {
            ptId: props.assinante.ptId,
            responsavelId: props.assinante.responsavelId,
            assinaturaTipo: props.tipoAssinatura,
            assinatura: pin.value,
          });

          quasar.notify({
            message: "PIN enviado com sucesso",
            color: "positive",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          restartSignature.value += 1;
          imagemBase64.value = null;
          emit("closeDialog");
          return;
        }

        if (props.tipoAssinatura == "eletronica") {
          await store.dispatch("pdt/enviarAssinaturaEncerramento", {
            ptId: props.assinante.ptId,
            responsavelId: props.assinante.responsavelId,
            assinaturaTipo: props.tipoAssinatura,
            assinatura: store.state.autenticacao.token,
          });

          quasar.notify({
            message: "Assinatura eletrônica enviada com sucesso",
            color: "positive",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          restartSignature.value += 1;
          imagemBase64.value = null;
          emit("closeDialog");
          return;
        }

        // buscarUrl para upload
        const resposta = await store.dispatch("pdt/getUpload", {
          ptId: props.assinante.ptId,
        });

        // inicio upload imagem
        let formAttributes = resposta.data.resultado.dados.formAttributes;
        let formInputs = resposta.data.resultado.dados.formInputs;

        const formData = new FormData();

        for (let input in formInputs) {
          formData.append(input, formInputs[input]);
        }

        let file = await fetch(imagemBase64.value).then((res) => res.blob());

        formData.append("file", file);
        var request = new XMLHttpRequest();
        request.open(formAttributes.method, formAttributes.action);
        await request.send(formData);
        // fim upload imagem

        // envio da assinatura
        await store.dispatch("pdt/enviarAssinaturaEncerramento", {
          ptId: props.assinante.ptId,
          responsavelId: props.assinante.responsavelId,
          assinaturaTipo: props.tipoAssinatura,
          assinatura: `${formAttributes.action}/${formInputs.key}`,
        });

        quasar.notify({
          message: "Assinatura Enviada com sucesso",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        restartSignature.value += 1;
        imagemBase64.value = null;
        emit("closeDialog");
      } catch (error) {
        const mensagemErro =
          error?.response?.data?.erro?.mensagem || "Erro ao enviar Assinatura";

        quasar.notify({
          message: mensagemErro,
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const removerAssinatura = async () => {
      try {
        await store.dispatch("pdt/removerAssinatura", {
          ptId: props.assinante.ptId,
          assinaturaId: props.assinante.assinaturas[0].assinaturaId,
        });
        quasar.notify({
          message: "Assinatura removida com sucesso",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        emit("closeDialog");
      } catch (error) {
        const mensagemErro =
          error?.response?.data?.erro?.mensagem ||
          "Erro a o excluir assinatura";

        quasar.notify({
          message: mensagemErro,
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const coletarImagem = async () => {
      try {
        if (
          imagemBase64.value === undefined &&
          props.tipoAssinatura == "facial"
        ) {
          quasar.notify({
            message: "A Face precisa ser coletada",
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          return;
        }

        await store.dispatch("pdt/enviarAssinaturaEncerramento", {
          ptId: props.assinante.ptId,
          responsavelId: props.assinante.responsavelId,
          assinaturaTipo: props.tipoAssinatura,
          assinatura: imagemBase64.value,
        });

        quasar.notify({
          message: "Face Enviada com sucesso",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        restartSignature.value += 1;
        imagemBase64.value = null;
        emit("closeDialog");
      } catch (error) {
        const mensagemErro =
          error?.response?.data?.erro?.mensagem || "Erro a o enviar Face";

        quasar.notify({
          message: mensagemErro,
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const coletarCracha = async () => {
      try {
        if (codigoCracha.value === "") {
          quasar.notify({
            message: "O código do crachá precisa ser inserido",
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          return;
        }

        await store.dispatch("pdt/enviarAssinaturaEncerramento", {
          ptId: props.assinante.ptId,
          responsavelId: props.assinante.responsavelId,
          assinaturaTipo: props.tipoAssinatura,
          assinatura: codigoCracha.value,
        });

        quasar.notify({
          message: "Crachá Enviado com sucesso",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        restartSignature.value += 1;
        codigoCracha.value = null;
        emit("closeDialog");
      } catch (error) {
        const mensagemErro =
          error?.response?.data?.erro?.mensagem || "Erro ao enviar Crachá";

        quasar.notify({
          message: mensagemErro,
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const biometriaVerificacao = (value) => {
      biometriaVerificacaoConst.value = value;

      setTimeout(() => {
        biometriaModal.value = false;
      }, 100);

      // Removendo a chamada automática - só deve processar quando clicar no botão "Confirmar Assinatura"
      if (value) {
        quasar.notify({
          message:
            "Biometria verificada com sucesso! Clique em 'Confirmar Assinatura' para continuar.",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {},
            },
          ],
        });
      }
    };

    const verificarPin = async () => {
      if (pin.value == "") {
        quasar.notify({
          message: "O campo não pode estar vazio",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        return false;
      }
      try {
        const response = await store.dispatch("requisicao/checarPin", {
          pin: pin.value,
          user_id: props.assinante.responsavelId,
        });
        if (response.data.result.pin_correto) {
          quasar.notify({
            message: "PIN validado com Sucesso.",
            color: "positive",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });

          return true;
        } else {
          quasar.notify({
            message: "PIN digitado, não corresponde ao pin do usuário!",
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          return false;
        }
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao validar pin",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return false;
      }
    };

    const fecharFacial = async () => {
      facial.value = false;
    };

    const receberFace = async (faceImage) => {
      imagemBase64.value = faceImage;

      facial.value = false;

      quasar.notify({
        message: "Face recebida com sucesso",
        color: "positive",
        actions: [
          {
            label: "fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
    };

    const validarCracha = async () => {
      if (codigoCracha.value === "") {
        quasar.notify({
          message: "O código do crachá não pode estar vazio",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    return {
      columns,
      atualizarImagem,
      coletarAssinatura,
      coletarBiometriaDigital,
      restartSignature,
      saveSignature,
      salvarSignature,
      removerAssinatura,
      tipoTitulo,
      biometriaModal,
      biometriaVerificacao,
      biometriaVerificacaoConst,
      atualizarBiometria,
      pin,
      facial,
      fecharFacial,
      receberFace,
      imagemBase64,
      coletarImagem,
      codigoCracha,
      coletarCracha,
      validarCracha,
    };
  },
};
</script>

<style scoped>
.canvas-container {
  width: 700px;
}
.assinatura-texto {
  font-size: 17px;
}
.imagem-biometria {
  height: 80px;
  width: 80px;
  cursor: pointer;
}
@media (max-width: 600px) {
  .canvas-container {
    width: 100%;
  }
  .assinatura-texto {
    font-size: 14px;
  }
}
</style>
